<template>
  <v-card class="mb-4" outlined>
    <v-card-title class="section-header">
      <v-icon left color="grey darken-1">mdi-silverware-variant</v-icon>
      {{ $t("menu_type") }}
    </v-card-title>
    <v-card-text class="pt-4">
      <v-row align="center">
        <v-col cols="12" sm="6">
          <autocomplete
            v-if="restaurant"
            :items="menuTypes"
            :label="$t('available_menu_type_for_comp')"
            item-text="filteredName"
            item-value="id"
            required
            @change="onChange"
            v-model="restaurant.company_restaurant_settings.menu_types_id"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="restaurant.company_restaurant_settings.everyday_offer"
            :false-value="0"
            :true-value="1"
            @change="onChange"
            color="#FF6B35"
            dense
            no-gutters
            class="mt-5"
            hide-details
            :label="$t('everyday_offer')"
          >
          </v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import hasSnackbar from "@/mixins/hasSnackbar";
import companyService from "@/services/company";

export default {
  name: "MenuTypeCard",
  mixins: [hasSnackbar],
  props: {
    restaurant: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
    menuTypes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onChange() {
      this.$emit("save");
    },
  },
};
</script>

<style scoped>
.section-header {
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}
</style>
